import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SidebarContextType {
  menuAberto: boolean;
  toggleMenu: () => void;
  fecharMenu: () => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [menuAberto, setMenuAberto] = useState(false);

  const toggleMenu = () => {
    setMenuAberto(prevState => !prevState);
  };

  const fecharMenu = () => {
    setMenuAberto(false);
  };

  return (
    <SidebarContext.Provider value={{ menuAberto, toggleMenu, fecharMenu }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = (): SidebarContextType => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebar deve ser usado dentro de um SidebarProvider');
  }
  return context;
};
